<script lang="ts">import Banners from "./parts/banners.svelte";
import Connects from "./parts/connects.svelte";
import Email from "./parts/email.svelte";
import Password from "./parts/password.svelte";
import Terms from "./parts/terms.svelte";
import Wallet from "./parts/wallet.svelte";
import { Button } from "@infinitro/button";
import { cfgBrandTitle, cfgGoogleClientId, ReleaseStage, stateUi, wantAtLeastReleaseStage } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { clearModals, closeThisModal, isMobile, loggedIn, ModalDialog, pushModal } from "@infinitro/global";
import { WarningIcon } from "@infinitro/icons";
import { Modal } from "@infinitro/modal";
import { Tabs } from "@infinitro/tabs";
import { Toggle } from "@infinitro/toggle";
import { stateConnectedWalletAddress } from "@infinitro/wallet_verify";
import { onMount } from "svelte";
import "swiper/swiper-bundle.css";
import BonusCode from "./parts/bonuscode.svelte";
import ReferalCode from "./parts/referalcode.svelte";
import { applyPreAuthIfCached, isModalOpen, preAuthentication, stateEmail, stateEmailVerified, stateError, stateFormMode, statePreauthenticated, stateReady, stateReset, stateShowPassword, stateSubmitting, stateTotpEnabled, stateWalletVerified, submit, zOverlay } from "./state";
import { CloseBehavior, FormMode } from "./types";
const BRAND_NAME = cfgBrandTitle();
const GOOGLE_CLIENT_ID = cfgGoogleClientId();
export let onclose = undefined;
let email = undefined;
let emailValid = false;
const validateEmail = (email) => {
	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailPattern.test(email);
};
const switchMode = (_mode) => {
	if (_mode === FormMode.Register) {
		console.log(`switching to register mode emailVerfied[${stateEmailVerified}] walletVerified[${$stateWalletVerified}]`);
		if (stateEmailVerified) return;
		if ($stateWalletVerified) return;
	}
	if (_mode === FormMode.Login) {
		stateEmail.set("");
	}
	stateFormMode.set(_mode);
};
const logout = () => {
	loggedIn.set(false);
	stateReset();
};
const closeModal = () => {
	stateReset();
	clearModals();
};
const handleEnableTotp = (e, checked) => stateTotpEnabled.set(checked);
const subscriptions = new Set();
onMount(() => {
	subscriptions.add(stateEmail.subscribe((value) => {
		email = value;
		emailValid = validateEmail(email);
	}));
	stateReset();
	if (!applyPreAuthIfCached()) {
		pushModal(ModalDialog.Loading);
		preAuthentication();
		closeThisModal(ModalDialog.Loading);
	}
	return () => {
		subscriptions.forEach((unsubscribe) => unsubscribe());
	};
});
$: useFlat = $stateUi.modal.modalStyle === "flat";
$: useGlass = $stateUi.modal.modalStyle === "glass";
$: useTinted = $stateUi.modal.modalStyle === "tinted";
$: flatActionButtonStyle = useFlat ? "height: 48px; background: var(--color-background-500); border-radius: 8px; color: var(--color-text-100); opacity: 0.5;" : "";
$: hideBanners = $stateUi.modal?.hideBanners ?? false;
$: useTightModalBodyPadding = $stateUi.auth?.useTightModalBodyPadding === true;
$: useOffsetModalCloseButton = $stateUi.auth?.useOffsetModalCloseButton === true;
$: hideReferalCode = $stateUi.auth?.hideReferalCode ?? false;
</script>

{#if $isModalOpen && !$loggedIn && $statePreauthenticated}
	<Modal
		width="100%"
		maxWidth={useFlat && !$isMobile ? '481px' : '600px'}
		padding={useFlat && !$isMobile
			? '40px'
			: !$isMobile && !useTightModalBodyPadding
				? '24px'
				: '0.5rem'}
		closeButtonBackground={!useFlat}
		noAnimation
		{closeModal}
		title={$isMobile ? $t(Verbiage.welcome_to_brand)?.replace('[BRAND]', BRAND_NAME) : ''}
		zIndexOverlay={$zOverlay}
		zIndexUnderlay={$zOverlay - 1}
		buttonCloseCustomStyles={!$isMobile && useOffsetModalCloseButton
			? 'top: 24px; right: 24px;'
			: ''}
	>
		<div
			class="auth-content"
			class:auth-content-flat={useFlat || useGlass || useTinted}
			class:auth-content-tinted={useTinted}
		>
			{#if !hideBanners}
				<Banners />
			{/if}
			<div class="content-container" class:auth-flat-content={useFlat}>
				{#if $loggedIn}
					<div class="logout">
						<a href={'#'} class="logout" on:click={logout}>{$t(Verbiage.logout)}</a>
					</div>
				{:else}
					{#if useFlat && !$isMobile}
						<h2 class="auth-flat-title">
							{$t(Verbiage.welcome)}
						</h2>
					{/if}
					<Tabs
						bind:activeTab={$stateFormMode}
						customClass={useFlat ? 'auth-flat-tabs' : ''}
						tabs={[
							{ label: $t(Verbiage.login), value: FormMode.Login, id: 'loginTab' },
							{ label: $t(Verbiage.register), value: FormMode.Register, id: 'signUpTab' }
						]}
						onChange={(detail) => switchMode(detail.value as FormMode)}
						size="large"
						transparentBackground={useTinted}
					/>
					<div class="content">
						{#if $stateError}
							<p class="error">
								<icon>
									<WarningIcon />
								</icon>
								<span>
									{$stateError}
									<br />
									{$t(Verbiage.contact_support_for_assistance)}
								</span>
							</p>
						{/if}
						<div class="email">
							{#if $stateConnectedWalletAddress}
								<Wallet />
							{:else}
								<Email />
							{/if}
						</div>
						{#if $stateFormMode === FormMode.Register && wantAtLeastReleaseStage(ReleaseStage.Alpha) && !hideReferalCode}
							<div class="sidebyside">
								{#if false}
									<BonusCode />
								{/if}
								<ReferalCode />
							</div>
						{/if}
						{#if $stateShowPassword}
							<Password />
						{/if}
						{#if $stateSubmitting}
							<h1 class="loading-text">Loading...</h1>
						{/if}
						{#if $stateFormMode === FormMode.Register}
							<Terms />
						{/if}
						{#if $stateFormMode === FormMode.Login || $loggedIn}
							<Button
								text={$t(Verbiage.login)}
								onClick={submit}
								disabled={$stateSubmitting || !($loggedIn || $stateReady)}
								fullWidth
								styleCustom={`${
									useFlat
										? `${flatActionButtonStyle} margin-top: 0.5rem;`
										: `${useTinted ? 'background-color: var(--color-background-500);' : ''} margin-top: 0.5rem;`
								}`}
								id="loginButton"
								variant={useFlat || useTinted ? 'secondary' : 'primary'}
							/>
							<!-- TODO: Adam check variant - transparent -->
						{:else if $stateFormMode === FormMode.Register}
							<Button
								text={$t(Verbiage.create_account)}
								onClick={submit}
								disabled={$stateSubmitting || !($loggedIn || $stateReady)}
								fullWidth
								id="createAccountButton"
								styleCustom={useFlat
									? flatActionButtonStyle
									: useTinted
										? 'background-color: var(--color-background-500);'
										: ''}
								variant={useFlat || useTinted ? 'secondary' : 'primary'}
							/>
							<div class="enable_totp {false ? 'enable_totp_enabled' : ''}">
								<span class="mr-2.5">{$t(Verbiage.twofa_setup)}</span>
								<Toggle onClick={handleEnableTotp} checked={$stateTotpEnabled} />
							</div>
						{/if}
					</div>
					{#if GOOGLE_CLIENT_ID}
						<div class="divider">
							<div class="line"></div>
							<div class="text">or</div>
							<div class="line"></div>
						</div>
					{/if}
					<Connects />
				{/if}
			</div>
		</div>
	</Modal>
{/if}

<style>
	.header {
		font-size: 1.25rem;
		line-height: 1.75rem;
		font-weight: 500;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

	.auth-content {
		position: relative;
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		padding-top: 0.25rem;
}

	@media (min-width: 1024px) {

		.auth-content {
				min-height: -moz-fit-content;
				min-height: fit-content;
		}
}

	.auth-content-flat {
		padding-top: 0.75rem;
}

	@media (min-width: 1024px) {

		.auth-content-flat {
				align-items: center;
				padding-top: 0px;
			gap: 32px;
		}
}

	.auth-content-tinted {
		margin-top: 1rem;
}

	.auth-flat-title {
		width: 100%;
		text-align: center;
		font-size: 1.5rem;
		line-height: 2rem;
		font-weight: 600;
		line-height: 140%;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

	.email {
		z-index: 40;
}

	.loading-text {
		margin-top: 0.5rem;
		margin-bottom: 0.5rem;
		text-align: center;
		font-size: 1.125rem;
		line-height: 1.75rem;
		font-weight: 500;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

	.content-container {
		display: flex;
		width: 100%;
		flex-direction: column;
		justify-content: flex-end;
		gap: 0.25rem;
		padding-top: 1rem;
		padding-bottom: 1rem;
}

	@media (min-width: 768px) {

		.content-container {
				justify-content: space-between;
		}

		.content-container > :not([hidden]) ~ :not([hidden]) {
				--tw-space-y-reverse: 0;
				margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
				margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
		}
}

	@media (min-width: 1024px) {

		.content-container {
				gap: 0.25rem;
		}
}

	@media (max-width: 390px) {

		.content-container {
				gap: 1rem;
		}
}

	.content {
		display: flex;
		height: 100%;
		flex-direction: column;
		justify-content: center;
		gap: 0.25rem;
}

	.content-container.auth-flat-content {
		width: 100%;
		gap: 1.5rem;
		padding-top: 0px;
		padding-bottom: 0px;
		max-width: 401px;
}

	.divider {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-bottom: 0.5rem;
		font-size: 0.75rem;
		line-height: 1rem;
		text-transform: uppercase;
		--tw-text-opacity: 1;
		color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

	.line {
		height: 1px;
		width: 33.333333%;
		--tw-bg-opacity: 1;
		background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

	.auth-content-flat .divider {
		gap: 1rem;
		padding-bottom: 0px;
		font-size: 1rem;
		line-height: 1.5rem;
		font-weight: 500;
		color: var(--color-text-500);
}

	.auth-content-flat .line {
		width: 100%;
		background: var(--color-text-100);
		opacity: 0.05;
}

	:global(.auth-flat-tabs) {
		background: var(--color-background-500) !important;
	}

	:global(.auth-flat-tabs button) {
		height: 52px !important;
	}

	:global(.auth-flat-tabs button:not(.inactive-tab)),
	:global(.auth-flat-tabs button:not(.inactive-tab):hover),
	:global(.auth-flat-tabs button:not(.inactive-tab):focus),
	:global(.auth-flat-tabs button:not(.inactive-tab):active) {
		background: var(--color-background-500) !important;
		color: var(--color-text-100) !important;
		opacity: 1 !important;
	}

	:global(
		.auth-flat-tabs
			button:is(.inactive-tab, .solid-static-inactive-tab, .tertiary-solid-static.inactive-tab)
	),
	:global(
		.auth-flat-tabs
			button:is(.inactive-tab, .solid-static-inactive-tab, .tertiary-solid-static.inactive-tab):is(
				:hover,
				:focus,
				:active,
				:focus-visible
			)
	) {
		background: transparent !important;
	}

	div.logout {
		text-align: right;
}

	a.logout {
		font-size: 0.75rem;
		line-height: 1rem;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

	div.mode {
		display: flex;
		border-radius: 0.5rem;
		padding: 0.25rem;
}

	.sidebyside {
		display: flex;
		width: 100%;
		flex-direction: row;
		justify-content: space-between;
}

	.link {
		position: relative;
		top: -20px;
		font-size: 0.875rem;
		line-height: 1.25rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		text-decoration-line: underline;
}

	.mode_selected {
		border-radius: 0.5rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
		font-weight: 800;
		text-transform: uppercase;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		--tw-shadow-color: var(--shadow-neutral);
		--tw-shadow: var(--tw-shadow-colored);
}

	.mode {
		z-index: 10;
		font-size: 0.875rem;
		line-height: 1.25rem;
		font-weight: 800;
		text-transform: uppercase;
		--tw-text-opacity: 1;
		color: rgb(229 231 235 / var(--tw-text-opacity, 1));
		margin-top: 0 !important;
}

	button.mode,
	button.mode_selected {
		width: 50%;
		cursor: pointer;
		padding: 0.625rem;
}

	button.close {
		position: absolute;
		top: 1rem;
		right: 0.75rem;
		display: flex;
		height: 2rem;
		width: 2rem;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem;
		font-size: 1rem;
		line-height: 1.5rem;
		font-weight: 500;
		--tw-text-opacity: 1;
		color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

	button.close:hover {
		--tw-border-opacity: 1;
		border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

	div.enable_totp {
		position: relative;
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: flex-end;
		padding-top: 0.5rem;
		text-align: right;
		font-size: 10px;
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

	div.enable_totp_enabled {
		--tw-text-opacity: 1;
		color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

	.error icon {
		margin-left: 1.25rem;
		margin-right: 1.25rem;
		margin-top: 0.5rem;
}

	.error {
		display: flex;
		font-size: 0.875rem;
		line-height: 1.25rem;
		--tw-text-opacity: 1;
		color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
</style>
